.atm_vy_1osqo2v{width:100%;}
.atm_ks_15vqwwr{overflow:hidden;}
.atm_sq_1l2sidv{text-overflow:ellipsis;}
.atm_vv_1q9ccgz{white-space:nowrap;}
